import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import PolicyBlackcard from '@/views/policy/PolicyBlackcard.vue';
import PolicyEscrow from '@/views/policy/PolicyEscrow.vue';
import PolicyProtocol from '@/views/policy/PolicyProtocol.vue';
import PolicyPrivacy from '@/views/policy/PolicyPrivacy.vue';

const policyRoutes: RouteConfig = {
  name: 'policy',
  path: '/policy',
  component: Main,
  redirect: {
    name: 'policy.protocol',
  },
  meta: {
    title: '安全和隐私',
  },
  children: [
    {
      name: 'policy.privacy',
      path: '/policy/privacy',
      component: PolicyPrivacy,
      meta: {
        title: '隐私权政策',
      },
    },
    {
      name: 'policy.protocol',
      path: '/policy/protocol',
      component: PolicyProtocol,
      meta: {
        title: '德友惠软件服务协议',
      },
    },
    {
      name: 'policy.blackcard',
      path: '/policy/blackcard',
      component: PolicyBlackcard,
      meta: {
        title: '高德黑卡商户服务协议',
      },
    },
    {
      name: 'policy.escrow',
      path: '/policy/escrow',
      component: PolicyEscrow,
      meta: {
        title: '服务托管协议',
      },
    },
  ],
};

export default policyRoutes;
